import { useSelectSearchModel } from '#pplx/frontend/apps/ask/hooks/search-model-selection-hooks/useSelectSearchModel.js';
import { useNativeBridgeActions } from '#pplx/frontend/apps/ask/native-bridges/store.js';
import { SEARCH_MODEL_CHANGE_CHANNEL } from '#pplx/frontend/components/utils/consts.js';
import { useCallback, useEffect, useRef } from 'react';
/**
 * A wrapper around useSelectSearchModel that broadcasts changes to other windows
 * @returns [selectModel] function that will sync model selection across windows
 */
export function useSharedSelectSearchModel({ openPaywallUpsell, }) {
    const rawSelectSearchModel = useSelectSearchModel({ openPaywallUpsell });
    const { publishIpcMessage, subscribeToIpcMessage } = useNativeBridgeActions();
    // Store rawSelectSearchModel in a ref to prevent recreating subscriptions
    const rawSelectSearchModelRef = useRef(rawSelectSearchModel);
    useEffect(() => {
        rawSelectSearchModelRef.current = rawSelectSearchModel;
    }, [rawSelectSearchModel]);
    // Set up IPC subscription for receiving updates
    useEffect(() => {
        return subscribeToIpcMessage(SEARCH_MODEL_CHANGE_CHANNEL, (data) => {
            if (data.type === SEARCH_MODEL_CHANGE_CHANNEL) {
                rawSelectSearchModelRef.current(data.model);
            }
        });
    }, [subscribeToIpcMessage]);
    // Wrap the selectSearchModel function to broadcast changes
    const sharedSelectSearchModel = useCallback((model) => {
        const applied = rawSelectSearchModelRef.current(model);
        if (!applied) {
            return false;
        }
        publishIpcMessage(SEARCH_MODEL_CHANGE_CHANNEL, {
            type: SEARCH_MODEL_CHANGE_CHANNEL,
            model,
        });
        return true;
    }, [publishIpcMessage]);
    return sharedSelectSearchModel;
}
//# sourceMappingURL=useSharedSelectSearchModel.js.map